import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {fetchQrDraftCount} from "./qrDraftActions";

const REFRESH_MS = 60000;

// Number of QR draft purchases, for the sidebar badge. One lightweight request (page size 1, reads
// totalCount) on every navigation and every 60 s. Errors keep the last known value.
export function useQrDraftCount(enabled = true) {
    const {pathname} = useLocation();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!enabled) return undefined;
        let mounted = true;
        const load = () => fetchQrDraftCount()
            .then(n => { if (mounted) setCount(n); })
            .catch(() => {});
        load();
        const timer = setInterval(load, REFRESH_MS);
        return () => { mounted = false; clearInterval(timer); };
    }, [enabled, pathname]);

    return count;
}
